module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isloading),
      expression: "isloading"
    }],
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 日期：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(30)
      }
    }
  }, [_vm._v("最近30天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 游戏来源：  \n\t\t\t\t "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "内部游戏",
      "value": "内部游戏"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部游戏",
      "value": "外部游戏"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 平台来源：  \n\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源"
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 小游戏名称：  \n\t\t\t\t"), _c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "platform_id": _vm.pdata.platform_id.toString(),
      "compare": "issued",
      "pholder": _vm.pholder
    },
    on: {
      "getid": _vm.changeId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 用户操作：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportIncome
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1)]), _vm._v(" "), (_vm.list.length > 0) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isloading),
      expression: "isloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [(item.key == 'ltv') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": '截至' + _vm.pdata.edate + '的累计数据',
              "placement": "top-start"
            }
          }, [_c('span', [_vm._v(_vm._s(item.name)), _c('i', {
            staticClass: "el-icon-question"
          })])]) : _c('span', [_vm._v(_vm._s(item.name))])]
        }
      }, {
        key: "default",
        fn: function(scope) {
          return [(item.key == 'banner_click_per') ? _c('span', {
            class: parseFloat(scope.row[item.key]) > 15 ? 'red' : ''
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (item.key == 'total_day_contribution') ? _c('span', {
            class: scope.row.isTop10 == true ? 'red' : ''
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (item.key == 'origin_day_contribution') ? _c('span', [(scope.row.origin_day_contribution_trend == 1) ? _c('span', {
            staticClass: "red"
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (scope.row.origin_day_contribution_trend == -1) ? _c('span', {
            staticClass: "green"
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]) : (item.key == 'jump_per') ? _c('span', [(scope.row.jump_per_trend == 1) ? _c('span', {
            staticClass: "red"
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (scope.row.jump_per_trend == -1) ? _c('span', {
            staticClass: "green"
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                'name': '产品日报详情',
                query: {
                  name: scope.row.issued_app_name,
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate
                },
                'params': {
                  issued_app_id: scope.row.issued_app_id
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 986043606)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出选择",
      "visible": _vm.checkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.checkDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.fieldListChange
    },
    model: {
      value: (_vm.FieldIndex),
      callback: function($$v) {
        _vm.FieldIndex = $$v
      },
      expression: "FieldIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "按字段设置",
      "name": "0"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按模块设置",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTapForModel(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _vm._l((_vm.selectFieldListForModel), function(value, key, index) {
    return _c('div', {
      staticClass: "fliedModel"
    }, [_c('div', {
      staticClass: "fliedModelKey"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('draggable', {
      attrs: {
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (_vm.selectFieldListForModel[key]),
        callback: function($$v) {
          _vm.$set(_vm.selectFieldListForModel, key, $$v)
        },
        expression: "selectFieldListForModel[key]"
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "tag": "ul"
      }
    }, _vm._l((value), function(item) {
      return _c('li', {
        key: item.key,
        staticClass: "item"
      }, [_c('i', {
        staticClass: "el-icon-rank"
      }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
        staticClass: "el-icon-close",
        on: {
          "click": function($event) {
            return _vm.removeSelectFieldForModel(item, key)
          }
        }
      })])
    }), 0)], 1)], 1)
  })], 2)])])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76067459"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/daily/productDaily.vue
// module id = 1145
// module chunks = 2